import { SubSink } from 'subsink';
import * as moment from 'moment';
import { isEmpty } from 'lodash';
import { TemplateService } from '../../../services/template.service';
import * as _ from 'lodash';
import { CALENDAR_LOCALE } from '../../../services/constant';
import { DownloadService } from '../download.service';
var DownloadRequestComponent = (function () {
    function DownloadRequestComponent(downloadService, template) {
        this.downloadService = downloadService;
        this.template = template;
        this.calendarLocale = CALENDAR_LOCALE.TH;
        this.startDate = new Date(moment().format('YYYY') + '-01-01');
        this.endDate = new Date(moment().format('YYYY') + '-12-30');
        this.taxID = '';
        this.documentNumber = '';
        this.email = '';
        this.isSuccess = false;
        this.loading = false;
        this.error = {};
        this.requestType = 0;
        this.allDocumentType = [];
        this.subs = new SubSink();
    }
    DownloadRequestComponent.prototype.ngOnInit = function () {
        // this.loadInput();
        // this.loadDropdown();
        this.rdDocumentType = this.template.getDropdown();
    };
    Object.defineProperty(DownloadRequestComponent.prototype, "yearRange", {
        get: function () {
            var thisYear = new Date().getFullYear();
            return thisYear - 40 + ':' + thisYear;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DownloadRequestComponent.prototype, "dateRange", {
        get: function () {
            var start = moment(this.startDate).format('DD/MM/YYYY');
            var end = moment(this.endDate).format('DD/MM/YYYY');
            return start + ' - ' + end;
        },
        enumerable: true,
        configurable: true
    });
    DownloadRequestComponent.prototype.setMinDate = function () {
        this.minDate = this.startDate;
        if (this.endDate < this.minDate) {
            this.endDate = this.minDate;
        }
    };
    DownloadRequestComponent.prototype.setMaxDate = function () {
        this.maxDate = this.endDate;
        if (this.startDate > this.maxDate) {
            this.startDate = this.maxDate;
        }
    };
    DownloadRequestComponent.prototype.validateEmail = function (email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    };
    DownloadRequestComponent.prototype.validateTaxID = function (taxID) {
        if (taxID == null || taxID === '') {
            return true;
        }
        return this.taxID.length === 13;
    };
    DownloadRequestComponent.prototype.validateInput = function () {
        this.validateEmail(this.email) === false
            ? (this.error['email'] = true)
            : delete this.error['email'];
        return this.error;
    };
    DownloadRequestComponent.prototype.submit = function () {
        var _this = this;
        this.error = {};
        if (!isEmpty(this.validateInput())) {
            return;
        }
        var data = {
            rd_doc_type: this.selectedRdDocumentType,
            buyer_name: this.buyerName,
            document_number: this.documentNumber,
            document_type_id: _.isNil(this.documentType)
                ? this.documentType
                : _.uniq(this.allDocumentType),
            document_start_date: this.startDate ? moment(this.startDate).format('YYYY-MM-DD') : '',
            document_end_date: this.endDate ? moment(this.endDate).format('YYYY-MM-DD') : '',
            email: this.email
        };
        this.loading = true;
        this.downloadService.createDocumentRequest(data).subscribe(function () {
            _this.isSuccess = true;
            _this.loading = false;
        });
    };
    DownloadRequestComponent.prototype.reloadPage = function () {
        location.reload();
    };
    DownloadRequestComponent.prototype.ngOnDestroy = function () {
        this.subs.unsubscribe();
    };
    return DownloadRequestComponent;
}());
export { DownloadRequestComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/download/download-request/download-request.component.ts.pre-build-optimizer.js